import { HeadContent, Outlet } from "@tanstack/react-router";

import ThemeProvider from "@/app/theme-provider";
import { Toaster } from "@buildpy/ui/sonner";

// 토스터는 여기 하나뿐이다 — 구간 레이아웃마다 달면 두 개씩 뜨고, 빠뜨리면 토스트가 조용히 사라진다(toaster.test).
const RootLayout = () => {
  return (
    <ThemeProvider
      disableTransitionOnChange
      enableSystem
      attribute="class"
      defaultTheme="system">
      {/* 브라우저 툴바 색(theme-color 라이트·다크)은 index.html 이 한 벌 싣는다 — 여기서 또 그리면 두 벌이 된다 */}
      <HeadContent />
      <Outlet />
      <Toaster />
    </ThemeProvider>
  );
};

export default RootLayout;
